import { MEASURE_SLUGS } from "~/consts";
import {
    AggregateFunctions,
    ApiQuery,
    Filter,
    FilterOperators,
    SortDirections,
} from "~/modules/filters/types";
import {
    TokenTimeseriesColumns,
    TokenTimeseriesGroupBy,
} from "~/modules/token_timeseries/types";

// // // //

export function buildNetFlowsQuery(props: {
    filters?: Filter[];
    groupBy: TokenTimeseriesGroupBy;
    startDate: Date;
    endDate?: Date;
    unit?: "dollar" | "token";
}): ApiQuery {
    const { filters, groupBy, startDate, endDate, unit = "dollar" } = props;

    const apiQuery: ApiQuery = {
        filter: {
            operator: FilterOperators.And,
            filters: [
                ...(filters || []),
                {
                    field: TokenTimeseriesColumns.date,
                    operator: FilterOperators.OnOrAfter,
                    value: startDate.toISOString(),
                },
                // Bound the upper end of the range when provided (e.g.
                // to the end of a financial quarter).
                ...(endDate
                    ? [
                          {
                              field: TokenTimeseriesColumns.date,
                              operator: FilterOperators.OnOrBefore,
                              value: endDate.toISOString(),
                          },
                      ]
                    : []),
                {
                    operator: FilterOperators.Or,
                    filters: [
                        {
                            field: TokenTimeseriesColumns.measureSlug,
                            operator: FilterOperators.Equals,
                            value: MEASURE_SLUGS[
                                `adjusted_daily_mints_${unit}`
                            ],
                        },
                        {
                            field: TokenTimeseriesColumns.measureSlug,
                            operator: FilterOperators.Equals,
                            value: MEASURE_SLUGS[
                                `adjusted_daily_burns_${unit}`
                            ],
                        },
                    ],
                },
            ],
        },
        aggregate: {
            groupBy,
            aggregateFunction: AggregateFunctions.Sum,
        },
        sort: {
            direction: SortDirections.asc,
            field: TokenTimeseriesColumns.date,
        },
        pagination: {
            page: 1,
            perPage: 25,
        },
    };

    return apiQuery;
}
